module.exports = __webpack_public_path__ + "static/flags/YI-20be027644a75145617d8afc17fb3dc8.gif";